import React, { useState, useEffect } from 'react'
import styles from './Header.module.scss'
import Logo from '../../../../assets/img/logo.png'
import { withTranslator } from '@common/hoc/translatorHoc'
import { WithI18nProps } from '@/types/i18n'
import { createAgentI18n } from '@/utils/i18n'
import { isProd } from '@/utils/utils'
import CustomButton from '@common/components/CustomButton'
import SimpleLanguageSelector from '@common/components/SimpleLanguageSelector'

interface HeaderProps {
  onJoin: () => void,
  // 判断是哪里引用的 header，如果是入驻页面，则做限制
  isJoinPage?: boolean
}

const Header: React.FC<HeaderProps & WithI18nProps> = (props) => {
  const [selectedRegion, setSelectedRegion] = useState('')
  const { i18n, onJoin, isJoinPage } = props
  const t = React.useMemo(() => createAgentI18n(i18n), [i18n])

  useEffect(() => {
    const currentLanguage = getCurrentLanguage()
    setSelectedRegion(currentLanguage)
  }, [i18n]) // eslint-disable-line react-hooks/exhaustive-deps

  const getCurrentLanguage = () => {
    if (!i18n) return 'zh-CN';
    return i18n.getLocale() || 'zh-CN';
  };

  const handleLanguageChange = (lang: string) => {
    setSelectedRegion(lang)
    i18n.changeLanguage(lang)
  }

  const goHome = () => {
    window.location.href = isProd() ? 'https://osm.dianping.com/os/h5/seek-investment/agentPc.html' : 'https://osm.51ping.com/os/h5/seek-investment/agentPc.html'
  }

  return (
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        <div className={styles.logoArea} onClick={goHome}>
          <img src={Logo} alt="Logo" className={styles.logo} />
          <span className={styles.title}>{t('logoTitle', "美团境外代理商")}</span>
        </div>
        {!isJoinPage && <div className={styles.navLinks}>
          <div className={`${styles.navLink} ${styles.active}`} onClick={goHome}>{t('home', "首页")}</div>
          {/* <div
            className={styles.navLink}
            onClick={onJoin}
          >
            {t('agentJoin', "代理商入驻")}
          </div> */}
          <div
            className={styles.navLink}
            onClick={() => window.open('https://www.dianping.com/overseas/openplatform/mt/main', '_blank')}
          >
            {t('openPlatform', "开放平台")}
          </div>
        </div>}
      </div>

      <div className={styles.headerRight}>
        {/* {!isJoinPage && <div className={styles.topLink}>
          <span>{t('downloadMeituanOverseasApp', '美团境外商家app')}</span>
          <div className={styles.qrDropdown}>
            <div className={styles.qrBox}>
              <img src={travelDownload} alt="QR" />
              <p>{t('downloadApp', '下载应用')}</p>
            </div>
          </div>
        </div>} */}

        <SimpleLanguageSelector
          selectedLanguage={selectedRegion}
          onLanguageChange={handleLanguageChange}
          className={styles.topLink}
        />

        {/* 复杂的地区语言选择器（备用）
        <RegionLanguageSelector
          selectedLanguage={selectedRegion}
          onLanguageChange={(country, lang) => handleLanguageChange(lang)}
          i18n={i18n}
          className={styles.topLink}
        />
        */}

        {!isJoinPage && <CustomButton variant='outline' className={styles.joinBtn} onClick={onJoin}>
          {t('wantToJoin', "立即合作")}
        </CustomButton>}
        <CustomButton
          variant='primary'
          onClick={() => window.open('https://poseidon.dianping.com/agent/agenthome', '_blank')}
        >
          {t('loginBackend', "登录代理商后台")}
        </CustomButton>
      </div>
    </header>
  )
}

const HeaderWithTranslator = withTranslator(Header)
export default HeaderWithTranslator
